import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Sidebar } from "flowbite-react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../auth/authContext/AuthContext";
import Permission from "../../../auth/Permission";
import "./SideMenu.scss";
import "../../../../../pages/MainLayout.scss";
import {
  FaUserFriends,
  FaPeopleArrows,
  FaBox,
  FaBoxes,
  FaMotorcycle,
  FaTools,
  FaTrailer,
  FaMoneyCheckAlt,
  FaFireExtinguisher,
  FaBuilding,
  FaFileInvoice,
  FaSearch,
} from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import { GiFullMotorcycleHelmet, GiTeacher } from "react-icons/gi";
import {
  BsClipboardData,
  BsSignStopLightsFill,
  BsCollectionPlayFill,
  BsPersonFillExclamation,
  BsWrenchAdjustableCircle,
} from "react-icons/bs";
import { BiSolidUserX } from "react-icons/bi";
import {
  MdCampaign,
  MdEngineering,
  MdOutlineAttachMoney,
  MdOutlineCreditScore,
  MdOutlineDragIndicator,
  MdOutlinePeople,
  MdOutlineSpaceDashboard,
  MdOutlineSupportAgent,
  MdWork,
} from "react-icons/md";
import { GrHostMaintenance } from "react-icons/gr";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { PiMotorcycleFill, PiUserSwitchDuotone } from "react-icons/pi";
import { SiCashapp, SiGoogleadsense } from "react-icons/si";
import {
  FaArrowRightArrowLeft,
  FaHandHoldingDollar,
  FaSackDollar,
  FaElementor,
  FaMeta,
  FaMessage,
} from "react-icons/fa6";

import { TbLockDollar, TbUserDollar } from "react-icons/tb";
import { RiNewspaperLine } from "react-icons/ri";

const menuStructure = [
  {
    label: "Dashboard",
    icon: RxDashboard,
    items: [
      {
        permission: "view:vehicles",
        path: "/dashboard/frota",
        label: "Frota",
        icon: PiMotorcycleFill,
      },

      {
        permission: "view:leads",
        path: "/dashboard/leads",
        label: "Comercial",
        icon: SiGoogleadsense,
      },
      {
        permission: "view:leads",
        path: "/dashboard/atendimento",
        label: "Atendimento",
        icon: MdOutlineSupportAgent,
      },
      {
        permission: "view:dashboard-maintenance",
        path: "/dashboard/manutencao",
        label: "Manutenção",
        icon: GrHostMaintenance,
      },
    ],
  },
  {
    label: "Cadastros",
    icon: FaUserFriends,
    items: [
      {
        permission: "view:renters",
        path: "/clientes",
        label: "Ativos",
        icon: GiFullMotorcycleHelmet,
      },
      {
        permission: "view:delinquency",
        label: "Recolhimento/Aguardando",
        path: "/aguardandoRecisao",
        icon: BsPersonFillExclamation,
      },
      {
        permission: "view:delinquency",
        label: "Finalizado/Rescisão",
        path: "/finalizados",
        icon: BiSolidUserX,
      },
      {
        permission: "view:leads",
        label: "Leads",
        path: "/leads",
        icon: () => (
          <img src="/lead-icon.svg" className="h-5 w-5" alt="Leads" />
        ),
      },
      {
        permission: "view:indicators",
        label: "Embaixadores",
        path: "/indicadores",
        icon: FaPeopleArrows,
      },
      {
        permission: "view:partners",
        label: "Parceiros",
        path: "/parceiros",
        icon: () => (
          <img src="/partnes-icon.svg" className="h-5 w-5" alt="Parceiros" />
        ),
      },
      {
        permission: "view:suppliers",
        label: "Fornecedores",
        path: "/fornecedores",
        icon: FaBuilding,
      },
      {
        permission: "view:companies",
        path: "/company-management",
        label: "Empresas",
        icon: MdWork,
      },
    ],
  },
  {
    label: "Frota",
    icon: MdEngineering,
    items: [
      {
        permission: "view:vehicles",
        label: "Gestão Operacional",
        path: "/operational-management",
        icon: MdOutlineSpaceDashboard,
      },
      {
        permission: "view:vehicles",
        label: "Manutenções",
        path: "/maintenances",
        icon: GrHostMaintenance,
      },
      {
        permission: "view:vehicles",
        label: "Veículos",
        path: "/veiculos",
        icon: FaMotorcycle,
      },
      {
        permission: "view:inventories",
        label: "Inventário",
        path: "/inventario",
        icon: FaBoxes,
      },
      {
        permission: "view:maintenance-schedule",
        label: "Agend. Manutenções",
        path: "/maintenance-schedules",
        icon: BsWrenchAdjustableCircle,
      },
      {
        permission: "view:maintenance",
        label: "Manutenção",
        path: "/manutencao",
        icon: FaTools,
      },
      {
        permission: "menu:repossession",
        label: "Recolhimento",
        path: "/recolhimento",
        icon: FaTrailer,
      },
      {
        permission: "menu:repossession",
        label: "Eventos",
        path: "/event-claim",
        icon: FaFireExtinguisher,
      },
      {
        permission: "view:vehicles",
        label: "Transferências de Veículos",
        path: "/vehicle-transfer",
        icon: FaArrowRightArrowLeft,
      },
      {
        permission: "view:vehicles",
        label: "Auditorias",
        path: "/audits",
        icon: FaSearch,
      },
    ],
  },
  {
    label: "Financeiro",
    icon: FaMoneyCheckAlt,
    items: [
      {
        permission: "view:vehicles",
        label: "Gestão de Cobranças",
        path: "/financeiro/gestao-cobranca",
        icon: MdOutlineCreditScore,
      },
      {
        permission: "view:vehicles",
        label: "Gestão de Faturas",
        path: "/financeiro/gestao-fatura",
        icon: FaHandHoldingDollar,
      },
      {
        permission: "view:vehicles",
        label: "Cobranças Negativadas",
        path: "/financeiro/negativados",
        icon: TbLockDollar,
      },
      {
        permission: "view:invoice-operation",
        label: "Gestão de Notas Fiscais",
        path: "/financeiro/gestao-fiscal",
        icon: FaFileInvoice,
      },
      {
        permission: "view:vehicles",
        label: "Boletos de Infrações",
        path: "/financeiro/infractionTickets",
        icon: RiNewspaperLine,
      },
      {
        permission: "view:vehicles",
        label: "Emprestimo",
        path: "/financeiro/emprestimo",
        icon: FaSackDollar,
      },
      {
        permission: "view:vehicles",
        label: "Devoluções de cauções",
        path: "/financeiro/caucao",
        icon: TbUserDollar,
      },
      {
        permission: "view:vehicles",
        label: "Renovações automaticas",
        path: "/financeiro/automaticRenewals",
        icon: PiUserSwitchDuotone,
      },
    ],
  },
  {
    label: "Estoque",
    icon: FaBox,
    items: [
      {
        permission: "view:stocks",
        label: "Estoque",
        path: "/estoque",
        icon: FaBox,
      },
      {
        permission: "view:purchase-order",
        label: "Compras",
        path: "/compras",
        icon: MdOutlineAttachMoney,
      },
    ],
  },
  {
    label: "Relatórios",
    icon: BsClipboardData,
    items: [
      {
        permission: "view:reports-maintenance",
        label: "Relatório de Manutenção",
        path: "/relatorios/manutencao",
        icon: GrHostMaintenance,
      },
      {
        permission: "view:reports-preparations",
        label: "Relatório de Preparações",
        path: "/relatorios/preparacoes",
        icon: FaMotorcycle,
      },
      {
        permission: "view:reports-trafficfines",
        label: "Relatório de Multas",
        path: "/relatorios/multas",
        icon: BsSignStopLightsFill,
      },
      {
        permission: "view:reports-repossession",
        label: "Relatório de Recolhimento",
        path: "/relatorios/recolhimento",
        icon: FaTrailer,
      },
      {
        permission: "view:reports-commissions",
        label: "Relatório de Comissões",
        path: "/relatorios/comissoes",
        icon: SiCashapp,
      },
      {
        permission: "view:reports-commissions",
        label: "Relatório de Indicações",
        path: "/relatorios/RelatorioIndicacoes",
        icon: MdOutlineDragIndicator,
      },
      {
        permission: "view:reports-contests",
        label: "Contestações",
        path: "/relatorios/contestacoes",
        icon: FaElementor,
      },
    ],
  },
  {
    label: "Recursos Humanos",
    icon: MdOutlinePeople,
    items: [
      {
        permission: "view:employee",
        label: "Colaboradores",
        path: "/colaboradores",
        icon: FaPeopleArrows,
      },
    ],
  },
  {
    label: "Marketing",
    icon: MdCampaign,
    items: [
      {
        permission: "view:marketing",
        label: "Template de Mensagens",
        path: "/marketing/messages-template",
        icon: FaMeta,
      },
      {
        permission: "view:marketing",
        label: "Campanhas",
        path: "/marketing/campaigns",
        icon: FaMessage,
      },
    ],
  },
  {
    label: "Suporte",
    icon: BsCollectionPlayFill,
    items: [
      {
        permission: "view:tutorial",
        label: "Tutorial",
        path: "/tutoriais",
        icon: GiTeacher,
      },
    ],
  },
];

export default function DefaultSidebar() {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  /* ---------- regra de embaixador ---------- */
  const isAmbassador = useMemo(() => {
    const roles = auth?.user?.roles ?? [];
    return roles.length === 1 && roles.includes("ambassador");
  }, [auth]);

  const structureToRender = useMemo(
    () =>
      isAmbassador
        ? menuStructure.filter((g) => g.label === "Cadastros")
        : menuStructure,
    [isAmbassador]
  );

  /* ---------- render ---------- */
  const [isSideMenuNames, setIsSideMenuNames] = useState(false);
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const stored = localStorage.getItem("openGroups");
    if (stored && !isAmbassador) setOpenGroups(JSON.parse(stored));
    const sidebar = document.querySelector(".side-bar");
    let t: NodeJS.Timeout;
    const enter = () => (t = setTimeout(() => setIsSideMenuNames(true), 1000));
    const leave = () => {
      clearTimeout(t);
      setIsSideMenuNames(false);
    };
    sidebar?.addEventListener("mouseenter", enter);
    sidebar?.addEventListener("mouseleave", leave);
    return () => {
      sidebar?.removeEventListener("mouseenter", enter);
      sidebar?.removeEventListener("mouseleave", leave);
      clearTimeout(t);
    };
  }, [isAmbassador]);

  const isActive = useCallback(
    (path: string) => location.pathname.startsWith(path),
    [location.pathname]
  );

  const toggleGroup = (label: string) => {
    setOpenGroups((prev) => {
      const updatedState: Record<string, boolean> = {};
      Object.keys(prev).forEach((key) => {
        updatedState[key] = false;
      });
      updatedState[label] = !prev[label];
      localStorage.setItem("openGroups", JSON.stringify(updatedState));
      return updatedState;
    });
  };

  if (isAmbassador) {
    return (
      <div className="side-menu">
        <Sidebar className="side-bar">
          <Sidebar.Items>
            <Sidebar.ItemGroup className="sidebar-items-reports">
              {structureToRender[0].items.map((subItem) => (
                <Permission key={subItem.path} permission={subItem.permission}>
                  <Sidebar.Item
                    className={`sidebar-item ${
                      isActive(subItem.path) ? "sidebar-item-active" : ""
                    }`}
                    onClick={() => navigate(subItem.path)}
                    icon={subItem.icon}
                  >
                    {subItem.label}
                  </Sidebar.Item>
                </Permission>
              ))}
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </Sidebar>
      </div>
    );
  }

  return (
    <div className="side-menu">
      <Sidebar className="side-bar">
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <div
              id="sideBarNames"
              className={`side-menu_entities ${isSideMenuNames ? "show" : ""}`}
            >
              {structureToRender.map((group) => {
                const groupItems = group.items.filter((item) => {
                  return auth?.user?.permissions?.includes(item.permission);
                });

                if (groupItems.length === 0) return null;

                const isGroupActive = groupItems.some((item) =>
                  isActive(item.path)
                );
                const isOpen = openGroups[group.label];

                return (
                  <div key={group.label}>
                    <Sidebar.Item
                      className={`sidebar-item ${
                        isGroupActive ? "sidebar-item-active" : ""
                      } sidebar-group`}
                      icon={group.icon}
                      onClick={() => toggleGroup(group.label)}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <span>{group.label}</span>
                        {isOpen ? (
                          <FaChevronDown className="sidebar-chevron" />
                        ) : (
                          <FaChevronRight className="sidebar-chevron" />
                        )}
                      </span>
                    </Sidebar.Item>
                    {isOpen && (
                      <Sidebar.Items className="sidebar-items-reports">
                        {groupItems.map((item) => (
                          <Permission
                            key={item.path}
                            permission={item.permission}
                          >
                            <Sidebar.Item
                              className={`sidebar-item sidebar-subitem ${
                                isActive(item.path) ? "sidebar-item-active" : ""
                              }`}
                              icon={item.icon}
                              onClick={() => navigate(item.path)}
                            >
                              {item.label}
                            </Sidebar.Item>
                          </Permission>
                        ))}
                      </Sidebar.Items>
                    )}
                  </div>
                );
              })}
            </div>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
}
